import cesDetailedDetailsLocale from './en.json'

const en = {
  cesDetailedDetails: cesDetailedDetailsLocale,
}

export default en
